
import authService from "../servicios/auth.service";

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import React, { useState, useEffect } from "react";
import PinInputModal from "../componentes/PinInputModal";
import SedesTabs from "../componentes/SedesTabs";
import { GlobalStyles, Typography } from '@mui/material';
import Logo from "../recursos/logo_samsic.png";

const PAGE_BG = "#eef1f4";
const SAMSIC_NAVY = "#2f4256";

function About() {
  const handlePinSubmit = (pin) => {
    console.log("PIN introducido:", pin);
    // Puedes agregar lógica adicional aquí si es necesario
  };
  useEffect(() => {
    document.title = "Samsic - Control Presencia";
  }, []);
  const salirPanel = () => {
    console.log('salirPanel')
    // mostrar teclado
    authService.comprobarPin('1920')

  }
  return (
    <>

      <CssBaseline />
      <GlobalStyles
        styles={{
          body: { backgroundImage: 'none', backgroundColor: PAGE_BG },
        }}
      />
      <Box
        sx={{
          bgcolor: PAGE_BG,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch'
        }}
      >
        {/* Cabecera Samsic */}
        <Box
          sx={{
            bgcolor: SAMSIC_NAVY,
            px: { xs: 2, md: 4 },
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: '#fff',
              borderRadius: 1,
              px: 1.5,
              py: 0.75,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img src={Logo} alt="Samsic" style={{ height: 32, display: 'block' }} />
          </Box>
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              letterSpacing: '.5px',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            Control Presencia
          </Typography>
          <PinInputModal onPinSubmit={handlePinSubmit} />
        </Box>

        <Container sx={{
          my: 3 ,
          maxWidth:{xs:"xs", xl:"xl"}
        }} >
          {/* <Box sx={{ bgcolor: 'rgba(161, 177, 53, 0.15)',m:3}} > */}
          <SedesTabs/>
          {/* </Box> */}

        </Container>
      </Box>




    </>
  );
}
export default About;
